// src/services/discoveryConfigService.js
import axiosInstance from "../api/axiosInstance"; // your configured axios

// ✅ Fetch list of configs with pagination & search
export const fetchDiscoveryConfigs = async (params) => {
  try {
    const response = await axiosInstance.get("/admin/discovery-config/list", {
      params,
    });
    return response.data;
  } catch (err) {
    throw err.response?.data || { message: "Failed to fetch data" };
  }
};

// ✅ Get a single config by ID
export const fetchDiscoveryConfigById = async (id) => {
  try {
    const response = await axiosInstance.get(`/admin/discovery-config/${id}`);
    return response.data;
  } catch (err) {
    throw err.response?.data || { message: "Failed to fetch config" };
  }
};

// ✅ Create a new config
export const createDiscoveryConfig = async (data) => {
  try {
    const response = await axiosInstance.post("/admin/discovery-config/add", data);
    return response.data;
  } catch (err) {
    throw err.response?.data || { message: "Failed to create config" };
  }
};

// ✅ Update config by ID
export const updateDiscoveryConfig = async (id, data) => {
  try {
    const response = await axiosInstance.put(`/admin/discovery-config/update/${id}`, data);
    return response.data;
  } catch (err) {
    throw err.response?.data || { message: "Failed to update config" };
  }
};

// ✅ Delete config by ID
export const deleteDiscoveryConfig = async (id) => {
  try {
    const response = await axiosInstance.delete(`/admin/discovery-config/delete/${id}`);
    return response.data;
  } catch (err) {
    throw err.response?.data || { message: "Failed to delete config" };
  }
};


// ✅ Bulk delete configs
export const deleteDiscoveryConfigBulk = async (ids) => {
  try {
    const response = await axiosInstance.post("/admin/discovery-config/deleteBulk", { ids });
    return response.data;
  } catch (err) {
    throw err.response?.data || { message: "Failed to delete configs" };
  }
};

// ✅ Toggle status of a config
export const toggleDiscoveryConfigStatus = async (id, data) => {
  try {
    const response = await axiosInstance.put(`/admin/discovery-config/status/${id}`, data);
    return response.data;
  } catch (err) {
    throw err.response?.data || { message: "Failed to update status" };
  }
};